export enum EventEmailCustomizationType {
  DAYS_REMINDER = "daysReminder",
  INVITE = "invite", // attendee invite
  MINUTES_REMINDER = "15MinutesReminder",
  REGISTRATION_CONFIRMATION = "registrationConfirmation",
}

export enum EventEmailCustomizationMediaType {
  IMAGE = "image",
  VIDEO = "video",
}

export interface IEmailCustomization {
  _id?: string;
  type: EventEmailCustomizationType;
  event: string;
  subject?: string;
  headerImageURL?: string;
  textBlock1?: string;
  textBlock2?: string;
  textBlock3?: string;
  textBlock4?: string;
  ctaButtonText?: string;
  mediaType?: EventEmailCustomizationMediaType;
  mediaURL?: string;
  mediaExtraImageURL?: string;
  senderImageURL?: string;
}
